// Import model
import { Prompt } from '../models/Prompt';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Message } from '../models/Message';

// Import dependency serializers (for complex types)
import { MessageSerializer } from './MessageSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Prompt - handles JSON serialization and deserialization with type validation
 */
export class PromptSerializer {
  /**
   * Deserializes a JSON string into a Prompt instance
   */
  static deserialize(json: string): Prompt {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Prompt instance
   */
  static fromObject(obj: any): Prompt {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Prompt');
    }


    const instance: Prompt = {
      assistantId: obj['AssistantId'] as string | undefined,
      assistantIdName: obj['AssistantId|Name'] as string | undefined,
      chatStatuses: obj['ChatStatuses'] ? (obj['ChatStatuses'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      messages: obj['Messages'] ? (obj['Messages'] as any[]).map((item: any) =>
        MessageSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Prompt instances
   */
  static deserializeArray(json: string): Prompt[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Prompt instance to a JSON string
   */
  static serialize(instance: Prompt): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Prompt instance to a plain object
   */
  static toObject(instance: Prompt): any {
    return {
      'AssistantId': instance.assistantId,
      'AssistantId|Name': instance.assistantIdName,
      'ChatStatuses': instance.chatStatuses?.map((item: any) =>
        item
      ),
      'Messages': instance.messages?.map((item: any) =>
        MessageSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of Prompt instances to a JSON string
   */
  static serializeArray(instances: Prompt[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
